module.exports = __webpack_public_path__ + "static/img/cabecera.09e5667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/cabecera.jpg
// module id = +9VS
// module chunks = 0